module.exports = __webpack_public_path__ + "static/media/application-crop-desktop.689f93d0.jpg";